import { put, takeLatest, call } from 'redux-saga/effects'
import fetchFromAPI, { getDefaultAutorizedHeaders } from 'helpers/fetchFromApi'
import UrlHelper from 'helpers/url'
import {
  API_URL_TRANSLATION_JOB_WORKFLOW_INPUT_ITEM,
  API_URL_TRANSLATION_JOB_WORKFLOW_INPUT_TABLE,
} from 'constants/index'
import NoticeHelper from 'helpers/notice'
import {
  TRANSLATION_JOB_WORKFLOW_INPUT_FETCH_TABLE_DATA,
  TRANSLATION_JOB_WORKFLOW_INPUT_FETCH_TABLE_DATA_SUCCESS,
  TRANSLATION_JOB_WORKFLOW_INPUT_FETCH_TABLE_DATA_FAILURE,
  TRANSLATION_JOB_WORKFLOW_INPUT_FETCH_FORM_DATA_SUCCESS,
  TRANSLATION_JOB_WORKFLOW_INPUT_FETCH_FORM_DATA_FAILURE,
  TRANSLATION_JOB_WORKFLOW_INPUT_FETCH_FORM_DATA,
  TRANSLATION_JOB_WORKFLOW_INPUT_CHANGE,
} from './reducer'
import { SHOW_NOTICE } from '../../notice'

function* translationsJobWorkflowInputFetchTableData(action) {
  try {
    const response = yield call(fetchFromAPI, {
      headers: getDefaultAutorizedHeaders(),
      partUrl: `${API_URL_TRANSLATION_JOB_WORKFLOW_INPUT_TABLE}${UrlHelper.getPsfsQuery(
        action.payload,
      )}`,
    })

    if (!response || !response.error) {
      yield put({
        type: TRANSLATION_JOB_WORKFLOW_INPUT_FETCH_TABLE_DATA_SUCCESS,
        payload: response,
      })
    } else {
      yield put({
        type: TRANSLATION_JOB_WORKFLOW_INPUT_FETCH_TABLE_DATA_FAILURE,
        error: response.errors,
      })
    }
  } catch (error) {
    console.log('TRANSLATION INTERFACE ERROR', error)
  }
}

function* translationsJobWorkflowInputFetchFormData(action) {
  try {
    const response = yield call(fetchFromAPI, {
      headers: getDefaultAutorizedHeaders(),
      partUrl: UrlHelper.create(API_URL_TRANSLATION_JOB_WORKFLOW_INPUT_ITEM, {
        id: action.payload.entityId,
      }),
    })
    if (!response || !response.error) {
      yield put({
        type: TRANSLATION_JOB_WORKFLOW_INPUT_FETCH_FORM_DATA_SUCCESS,
        payload: response,
      })
    } else {
      yield put({
        type: TRANSLATION_JOB_WORKFLOW_INPUT_FETCH_FORM_DATA_FAILURE,
        error: response.errors,
      })
    }
  } catch (error) {
    console.log('TRANSLATION ERROR', error)
  }
}

function* translationsJobWorkflowInputChange(action) {
  try {
    const { entityId, values } = action.payload
    const response = yield call(fetchFromAPI, {
      headers: getDefaultAutorizedHeaders(),
      method: 'PUT',
      partUrl: UrlHelper.create(API_URL_TRANSLATION_JOB_WORKFLOW_INPUT_ITEM, {
        id: entityId,
      }),
      data: values,
    })

    if (response.error) {
      return yield call(action.promise.resolve, response.errors)
    }

    yield put({
      type: SHOW_NOTICE,
      notice: NoticeHelper.createSuccessObj(
        `Job Workflow Translation ${
          entityId === 0 ? 'create' : 'change'
        } successful`,
      ),
    })

    return yield call(action.promise.resolve, false)
  } catch (error) {
    throw new Error(`TRANSLATION INTERFACE ERROR: ${error}`)
  }
}

function* translationsJobWorkflowInputSaga() {
  yield takeLatest(
    TRANSLATION_JOB_WORKFLOW_INPUT_FETCH_TABLE_DATA,
    translationsJobWorkflowInputFetchTableData,
  )
  yield takeLatest(
    TRANSLATION_JOB_WORKFLOW_INPUT_FETCH_FORM_DATA,
    translationsJobWorkflowInputFetchFormData,
  )
  yield takeLatest(
    TRANSLATION_JOB_WORKFLOW_INPUT_CHANGE,
    translationsJobWorkflowInputChange,
  )
}

export default translationsJobWorkflowInputSaga
